<template>
  <div>
    <div
      :class="[
        dataOfferNotValid || !dataIsApplicable
          ? 'offerCardDisabled'
          : 'offerCard',
      ]"
      @click="triggerOfferDetailsContent()"
    >
      <div v-if="dataOfferNotification" class="offerNotification">
        <p class="offerNotificationText">{{ dataOfferNotification }}</p>
      </div>
      <div class="flex-row p16">
        <div class="offerCardLeft flex-column">
          <div class="d-flex pl12">
            <span v-if="dataLogo" class="pt6 pl12 pb6 pr12"
              ><img :src="dataLogo"
            /></span>
            <span
              v-if="dataPromoCode"
              :class="
                dataOfferNotification ? 'disableCouponCode' : 'couponCode'
              "
              @click="copyCouponCode(dataPromoCode)"
              >{{ dataPromoCode }}</span
            >
            <div v-if="showTooltip" class="coupon-tooltip-card">Copied!</div>
          </div>
          <!-- <span
          :class="dataOfferNotification ? 'disableCouponTitle' : 'couponTitle'"
          class="pl10"
          >{{ dataTitle }}</span
        > -->
          <div class="displaybox">
            <div class="h56">
              <p
                :class="
                  dataOfferNotification
                    ? 'disableCouponDisplayMessage'
                    : 'couponDisplayMessage'
                "
              >
                {{ dataDisplayMessage }}
              </p>
            </div>
            <div v-if="!isDesktop" class="d-flex align-items-center">
              <button
                class="astext medium pb4"
                @click="triggerOfferDetailsModal()"
              >
                More Details
              </button>
              <i class="hkfi-arrow-line rotate90 showMoreDetails"></i>
            </div>
          </div>
        </div>
        <!-- <hr :class="dataAction == 'Remove' ? 'lineSelected' : 'line'" /> -->
        <div class="offerCardRight flex-column">
          <span class="offercardtext tc">{{ dataText }}</span>
          <button
            v-if="!isDesktop && !dataOfferNotification && dataIsApplicable"
            :class="
              dataOfferNotification
                ? 'disabledbutton medium bold ml10'
                : 'enabledbutton bold ml10 btn'
            "
            @click="triggerofferSelected"
          >
            {{ dataAction }}
          </button>
        </div>
      </div>
    </div>
    <div
      :class="
        dataIsApplicable ? 'bottom-offer-card-msg' : 'bottom-offer-card-msg-err'
      "
      v-if="dataBottomMsg"
    >
      <span class="fs-12" :class="{ width60: !dataIsApplicable }">{{
        dataBottomMsg
      }}</span
      ><span
        v-if="!dataIsApplicable"
        class="color-primary fs-14 bold"
        @click="goToMenu"
        >Add Items</span
      >
    </div>
  </div>
</template>
<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { clientPlatform } from "../config/apiEndpoints";
import {
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_OFFER_SELECT,
  EVENT_CLICK_ADD_MORE_ITEMS,
} from "../helpers/analyticsEvents";

export default {
  name: "OfferListingCard",
  props: [
    "dataIndex",
    "dataTitle",
    "dataPromoCode",
    "dataDisplayMessage",
    "dataText",
    "dataOfferList",
    "dataAction",
    "dataLogo",
    "dataOfferType",
    "dataItemTnc",
    "dataSelectedOffer",
    "dataSectionPosition",
    "dataOfferNotValid",
    "dataIsApplicable",
    "dataBottomMsg",
  ],
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
      showTooltip: false,
      // dataOfferNotification: "Add 30 rs to proceed"
    };
  },
  mounted() {
    EVENT_IMPRESSION_OFFERS({
      sectionName: this.dataTitle,
      sectionPosition: this.dataIndex + 1,
      positionWithinSection: "",
    });
  },
  methods: {
    goToMenu() {
      EVENT_CLICK_ADD_MORE_ITEMS();
      Utility.sendToMenuScreen();
    },
    async copyCouponCode(couponCode) {
      try {
        await navigator.clipboard.writeText(couponCode);
        this.showTooltip = true;
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      } catch (err) {
        console.error("Unable to copy text to clipboard", err);
      }
    },
    triggerOfferDetailsModal() {
      EVENT_CLICK_VIEWMORE_OFFER_CARD({
        couponCode: this.dataPromoCode,
        sectionPosition: this.dataSectionPosition,
        positionWithinSection: this.dataIndex + 1,
      });
      document.body.classList.add("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);

      this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
        campaignId: this.dataItemTnc,
      });

      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER,
        this.offersList.find((i) => i.couponCode == this.dataPromoCode)
      );
    },
    triggerOfferDetailsContent() {
      if (this.isDesktop) {
        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          campaignId: this.dataItemTnc,
        });

        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER,
          this.offersList.find((i) => i.couponCode == this.dataPromoCode)
        );
      }
    },
    triggerofferSelected() {
      if (this.$store.state.Offers.appliedOfferPromo != this.dataPromoCode) {
        if (this.isCartSelected) {
          this.$store.dispatch(keyMapsAction.APPLY_OFFER_API, {
            couponCode: this.dataPromoCode,
          });
          this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
          setTimeout(this.closeAppliedModal, 3000);
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
            this.dataPromoCode
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
            false
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
            this.dataIndex
          );
          EVENT_CLICK_OFFER_SELECT({
            subCategory: "selected",
            sectionPosition: this.dataSectionPosition,
            positionWithinSection: this.dataIndex + 1,
            category: this.dataPromoCode,
          });
          LocalStorageFunc.updateCouponCode(this.dataPromoCode);
          this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
          this.$store.commit(keyMapsMutation.UPDATE_VIEW_ALL_OFFERS, false);
          if (window.location.href?.includes("/store")) {
            this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
            setTimeout(this.closeAppliedModal, 3000);
          } else {
            LocalStorageFunc.setOfferAppliedModal(true);
            Utility.redirectToHomeOrRedirectUrl();
          }
        }
      } else {
        if (this.isCartSelected) {
          this.$store.dispatch(keyMapsAction.REMOVE_OFFER_API, {
            couponCode: this.dataPromoCode,
          });
        } else {
          EVENT_CLICK_OFFER_SELECT({
            subCategory: "unselected",
            sectionPosition: this.dataSectionPosition,
            positionWithinSection: this.dataIndex + 1,
            category: this.dataPromoCode,
          });
          this.$store.commit(keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO, "");
          LocalStorageFunc.updateCouponCode("");
          this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
        }
      }
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },

    closeofferSelectedModal() {
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },
  },
  computed: {
    isDesktop() {
      return Utility.isDesktop();
    },
    paymentSelectedOfferIndex() {
      return this.$store.state.PaymentOffers.paymentSelectedOfferIndex;
    },
    selectedPaymentOfferTnc() {
      return this.$store.state.PaymentOffers.selectedPaymentOfferTnc;
    },
    dataOfferNotification() {
      return "";
    },
    isCartSelected() {
      return LocalStorageFunc.getPrevUrl().includes("/cart");
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
  },
};
</script>
<style></style>
